import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUploadedDocument,
  getAppDocuments,
  getAppDocusignDocs,
  getAppFormLibrary,
  getAppTasks,
  getCandidateApps,
  getUploadDocDeleteStatus,
  loadAppDocuments,
  loadAppDocusignDocs,
  loadAppFormLibrary,
  loadAppRuningTasks,
  loadCandidateApps,
  uploadedDocumentDeleted,
} from "../../store/candidate";
import {
  getCurrentClientDeatils,
  getCurrentUser,
  getLoggedUserDetails,
  loadClientDetails,
  loadUserDetails,
  sign,
} from "../../store/auth";
import { useNavigate } from "react-router-dom";
import { getFieldData } from "../../../Services/appService";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import ViewForm from "../../../Components/ApplicantProcessing/ViewForm";
import {
  getReqDocuments,
  getSignedDocumentData,
  loadReqDocuments,
  loadSignedDocument,
  signedDocumentReceived,
} from "../../store/documents";
import useDocDownload from "../../hooks/useDocDownload";
import {
  getComponentUserStatus,
  UpdateComponentsUserStatus,
} from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getDocDeletedStatus, partnerCandidateDocDelete } from "../../store/partner";

const CONTRACT_DOC_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  headerActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.25,
    margin: 0,
  },
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "15px",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#64748b",
    margin: 0,
  },
  heroButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  cardBody: {
    padding: "18px 22px 22px 22px",
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)",
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  statValue: {
    fontSize: "26px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1,
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0,
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
  },
  table: {
    marginBottom: 0
  },
  serialColumn: {
    width: "7%",
  },
  dateColumn: {
    width: "17%",
  },
  requirementColumn: {
    width: "25%",
  },
  notesColumn: {
    width: "23%",
  },
  statusColumn: {
    width: "13%",
  },
  actionColumn: {
    width: "15%",
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
  },
  cell: {
    verticalAlign: "middle",
    padding: "18px 16px",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
  },
  serialBadge: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "13px",
    fontWeight: 800,
  },
  datePrimary: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "4px",
  },
  dateSecondary: {
    fontSize: "12px",
    color: "#64748b",
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent",
  },
  textButton: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
  },
  ellipsisLink: {
    border: "none",
    background: "transparent",
    color: "#4361d9",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
    display: "inline-block",
    maxWidth: "260px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  iconButton: {
    width: "32px",
    height: "32px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.05)",
  },
  infoIconButton: {
    color: "#56607a",
  },
  deleteIconButton: {
    color: "#dc2626",
  },
  requirementPrimary: {
    display: "block",
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  requirementSecondary: {
    display: "block",
    fontSize: "13px",
    color: "#0f172a",
    marginTop: "4px",
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  dangerButton: {
    border: "none",
    background: "transparent",
    color: "#dc2626",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
  },
  actionGroup: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    minWidth: 0,
  },
};

export default function ContractDocs() {
  const usrType = localStorage.getItem("userType");

  const [appTasklist, setAppTasklist] = useState([]);
  const [entityType, setEntityType] = useState("");
  const [signDocs, setSignDocs] = useState([]);
  const [sentDocs, setSentDocs] = useState([]);
  const [receivedDocs, setReceivedDocs] = useState([]);
  const [appFormLibrary, setAppFormLibrary] = useState([]);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [docLoading, setDocLoading] = useState(false);
  const [docLoadingId, setDocLoadingId] = useState(0);
  const [signLoading, setSignLoading] = useState(false);
  const [uploadDocShowHide, setUploadDocShowHide] = useState(false);
  const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [docType, setDocType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [formShowHide, setFormShowHide] = useState(false);
  const [formObj, setFormObj] = useState(null);
  const [clientDetails, setClientDetails] = useState(null);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appTasksSelector = useSelector(getAppTasks);
  const appDocumentsSelector = useSelector(getAppDocuments);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const appDocusignDocSelector = useSelector(getAppDocusignDocs);
  const signedDocumentDataSelector = useSelector(getSignedDocumentData);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);
  const uploadDocDeleteStatusSelector = useSelector(getUploadDocDeleteStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const navigate = useNavigate();

  const route = [
    { name: "Task Management", url: "" },
    { name: "Onboarding Steps", url: "" },
  ];
  const route1 = [
    { name: "Contract Management", url: "" },
    { name: "Enrollment Steps", url: "" },
  ];

  useEffect(() => {
    dispatch(setCurrentPageTitle("STEP-2 : Contract Documents"));
    dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    dispatch(loadClientDetails());
  }, []);

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;

    if (!userDetailsSelector && currentUser?.id > 0)
      dispatch(loadUserDetails(usrId));

    if (candidateAppsSelector?.length === 0 && currentUser?.id > 0) {
      dispatch(loadCandidateApps(usrId));
    }
    if (appDocusignDocSelector?.length === 0 && currentUser?.id > 0) {
      dispatch(loadAppDocusignDocs(usrId));
    }
  }, []);

  useEffect(() => {
    if (appDocusignDocSelector?.length > 0) {
      const docusignDocs = appDocusignDocSelector.filter(
        (x) => x.sendStatus === true
      );
      setSignDocs(docusignDocs);
    } else {
      setSignDocs(appDocusignDocSelector);
    }
  }, [appDocusignDocSelector]);

  useEffect(() => {
    setUserDetails(userDetailsSelector);
  }, [userDetailsSelector]);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(
        (x) => x.workflowType === 1
      );
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        setWfId(wf.oldWorkflowId);
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        if (currentUser?.id > 0) {
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
          dispatch(loadAppFormLibrary(wf.oldWorkflowId, usrId));
          dispatch(loadAppDocuments(wf.oldWorkflowId, usrId));
        }
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(
        (x) => x.taskType === 1 && x.wiid > 0
      );
      setAppTasklist(filterTasks);

      if (filterTasks.length > 0) {
        dispatch(loadReqDocuments(filterTasks[0].ciid));
      }

      if (appTasksSelector.length > 0) {
        const entType = getFieldData(
          appTasksSelector[0].stateData,
          "candidateonboardingform",
          "CandidateEntity"
        );
        setEntityType(entType);
      }
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (appDocumentsSelector.length > 0) {
      const appDocs = appDocumentsSelector;

      let receiveDoc = appDocs.filter(
        (x) =>
          x.type === "received" &&
          x.uploadType !== "Invoice" &&
          x.uploadType !== "reporting" &&
          x.uploadType !== "client" &&
          x.uploadType !== "project" &&
          x.docType !== "internal" &&
          x.docType !== "Messaging" &&
          x.docModifiedName !== "esign" &&
          //!x.docType?.includes("_c2c") &&
          x.sendStatus === true &&
          x.deleteFlag !== true
      );
      let sentDocs = appDocs.filter(
        (x) =>
          x.type === "send" &&
          x.uploadType !== "Invoice" &&
          x.docType !== "internal" &&
          x.docType !== "Messaging" &&
          x.uploadType !== "Messaging" &&
          x.uploadType !== "reporting" &&
          x.uploadType !== "monthly_time_sheet" &&
          x.uploadType !== "weekly_time_sheet" &&
          x.uploadType?.substring(0, 3) !== "ach" &&
          x.uploadType?.substring(0, 3) !== "req" &&
          x.uploadType?.substring(0, 9) !== "insurance"
      );
      setReceivedDocs(receiveDoc);
      setSentDocs(sentDocs);

      let docItems = "";
      receiveDoc.forEach((x, key) => {
        if (key > 0) docItems += ",";
        docItems += x.id;
      });

      sentDocs.forEach((x, key) => {
        if (key > 0 || docItems !== "") docItems += ",";
        docItems += x.id;
      });

      appDocs
        .filter((x) => x.docModifiedName === "esign")
        .forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

      let appCiid = 0;
      if (receiveDoc.length > 0) appCiid = receiveDoc[0].ciid;

      if (sentDocs.length > 0) appCiid = sentDocs[0].ciid;

      handleUpdateComponent(docItems, appCiid);
    }
  }, [appDocumentsSelector]);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const frmLibrary = appFormLibrarySelector.filter(
        (x) =>
          x.formType !== "ACH Information" &&
          x.formType !== "Insurance Information"
      );
      setAppFormLibrary(frmLibrary);
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    if (reqDocumentsSelector.length > 0) {
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      const reqDocs = reqDocumentsSelector.filter(
        (x) =>
          x.sendStatus === true && x.performerId === parseInt(usrId)
      );
      setReqDocuments(reqDocs);

      if (reqDocs.length > 0) {
        let docItems = "";
        receivedDocs.forEach((x, key) => {
          if (key > 0) docItems += ",";
          docItems += x.id;
        });

        sentDocs.forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

        reqDocs.forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

        let appCiid = 0;
        if (receivedDocs.length > 0) appCiid = receivedDocs[0].ciid;

        if (sentDocs.length > 0) appCiid = sentDocs[0].ciid;

        handleUpdateComponent(docItems, appCiid);
      }
    }
  }, [reqDocumentsSelector]);

  const handleViewSignedDoc = (item, type) => {
    setSelectedSignedDoc(item);
    setSignLoading(true);
    dispatch(loadSignedDocument(item.id, type));
  };

  useEffect(() => {
    if (signedDocumentDataSelector && selectedSignedDoc) {
      // const url = window.URL.createObjectURL(signedDocumentDataSelector);
      // const link = document.createElement("a");
      // link.href = url;
      // link.target = "_blank";

      // if (selectedSignedDoc?.docName)
      //   link.setAttribute("download", selectedSignedDoc.docName);
      // else if (selectedSignedDoc?.documentName)
      //   link.setAttribute("download", selectedSignedDoc.documentName);
      // else link.setAttribute("download", "ipcs_document");

      // document.body.appendChild(link);
      // link.click();
      // link.parentNode.removeChild(link);
      window.open(signedDocumentDataSelector.uploadUrl, "_blank");
      setSelectedSignedDoc(null);
      setSignLoading(false);
      dispatch(signedDocumentReceived(null));
    }
  }, [signedDocumentDataSelector]);

  useEffect(() => {
    setClientDetails(currentClientDeatilsSelector);
  }, [currentClientDeatilsSelector]);

  const handleUploadShowHide = (type) => {
    if (type === "save") {
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      setUploadDocShowHide(false);
      dispatch(loadAppDocuments(wfId, usrId));
    } else {
      const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
      if (reviewApp.length > 0) {
        const lastReviewer = reviewApp[0];
        setWfTask([lastReviewer]);
      } else {
        getAlert("", "No reviewer found", "error");
      }
      setUploadDocShowHide(!uploadDocShowHide);
      setDocType(type);
    }
  };

  const handleFormShowHide = (frm) => {
    if (frm === "save") {
      setFormShowHide(false);
      setFormObj("");
    } else {
      setFormShowHide(!formShowHide);
      setFormObj(frm);
    }
  };

  const handleDeleteFile = async (doc, type, item) => {
    if (item?.status === 1) return getAlert("", "You cannot delete approved document", "error");
    if (item?.docStatus === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      dispatch(deleteUploadedDocument(doc.id, type));
    }
  };

  useEffect(() => {
    if (uploadDocDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      dispatch(uploadedDocumentDeleted(false));
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (wfId > 0)
        dispatch(loadAppDocuments(wfId, usrId));
    }
  }, [uploadDocDeleteStatusSelector])

  const getReqUploadedDocs = (item, type) => {
    const achDocs = appDocumentsSelector.filter(
      (x) => x.docType === `req_${item.id}`
    );

    if (achDocs.length === 0) {
      return (
        <>
          <td style={CONTRACT_DOC_STYLES.cell}>
            <span style={getStatusPillStyles(
              item.docType?.includes("_c2c_")
                ? "contract"
                : item.docType !== "sharing" && !item.docType?.includes("_c2c_") && type !== "received"
                  ? "pending"
                  : "received"
            )}>
              {item.docType?.includes("_c2c_") && "Contract"}
              {item.docType !== "sharing" &&
                !item.docType?.includes("_c2c_") &&
                type !== "received"
                ? "Pending"
                : type === "received" && "Received"}
            </span>
          </td>
          <td style={CONTRACT_DOC_STYLES.cell}>
            {item.docType !== "sharing" &&
              !item.docType?.includes("_c2c_") &&
              type !== "received" && (
                <button
                  className="btn btn-sm"
                  style={CONTRACT_DOC_STYLES.primaryButton}
                  onClick={() => handleUploadShowHide(`req_${item.id}`)}
                >
                  <i className="fa fa-upload"></i> Upload
                </button>
              )}
          </td>
        </>
      );
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return (
        <>
          <td style={CONTRACT_DOC_STYLES.cell}>
            <span style={getStatusPillStyles("uploaded")}>Uploaded</span>
          </td>
          <td style={CONTRACT_DOC_STYLES.cell}>
            <div style={CONTRACT_DOC_STYLES.actionGroup}>
              <button
                className="btn btn-sm p-0"
                style={CONTRACT_DOC_STYLES.ellipsisLink}
                title={doc.documentName}
                aria-label={doc.documentName}
                onClick={() => handleDownloadFile(doc)}
              >
                {getDisplayName(doc.documentName)}
              </button>
              {getPopover(doc.notes)}
              <button
                className="btn btn-sm p-0"
                style={{
                  ...CONTRACT_DOC_STYLES.iconButton,
                  ...CONTRACT_DOC_STYLES.deleteIconButton,
                }}
                title="Delete File"
                onClick={() => handleDeleteFile(doc, "doc", item)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </div>
          </td>
        </>
      );
    }
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentsSelector.filter(
        (x) => x.uploadId === item.refDocId
      );
      if (findDocs.length > 0) {
        return (
          <>
            {findDocs.map((doc) => (
              <td key={doc.id} style={CONTRACT_DOC_STYLES.cell}>
                <button
                  className="btn btn-sm p-0"
                  style={{
                    ...CONTRACT_DOC_STYLES.textButton,
                    ...CONTRACT_DOC_STYLES.requirementPrimary,
                  }}
                  title={doc.documentName}
                  aria-label={doc.documentName}
                  onClick={() => handleDownloadFile(doc)}
                >
                  {getDisplayName(doc.documentName)}
                </button>
                <span
                  style={CONTRACT_DOC_STYLES.requirementSecondary}
                  title={item.documnetName}
                >
                  {item.documnetName}
                </span>
              </td>
            ))}
          </>
        );
      }
    }

    return (
      <td style={CONTRACT_DOC_STYLES.cell}>
        <span
          style={CONTRACT_DOC_STYLES.requirementSecondary}
          title={item.documnetName}
        >
          {item.documnetName}
        </span>
      </td>
    );
  };

  const getUnsignedDoc = (item) => {
    const signDoc = appDocumentsSelector.filter(
      (x) => x.docData === item.docData
    );
    if (signDoc.length === 0) {
      return (
        <>
          <td>{item.documentName}</td>
        </>
      );
    }

    if (signDoc.length > 0) {
      const doc = signDoc[0];
      return (
        <>
          <td>
            <button
              className="btn btn-sm p-0"
              style={CONTRACT_DOC_STYLES.textButton}
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              {doc.documentName}
            </button>
          </td>
        </>
      );
    }
  };

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter((x) => x.compId === 3);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Contract Document",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 3,
    };
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  };

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i
          className="fa fa-info-circle"
          style={{
            ...CONTRACT_DOC_STYLES.iconButton,
            ...CONTRACT_DOC_STYLES.infoIconButton,
            cursor: "pointer",
          }}
        ></i>
      </OverlayTrigger>
    );
  };

  const getPopover1 = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm" style={CONTRACT_DOC_STYLES.subtleButton}>View</button>
      </OverlayTrigger>
    );
  };

  const getDisplayName = (name) => {
    if (!name) return "";
    return name.length > 10 ? `${name.slice(0, 10)}...` : name;
  };

  const getStatusPillStyles = (type) => {
    if (type === "uploaded" || type === "signed" || type === "received") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#166534",
        backgroundColor: "#f0fdf4",
        borderColor: "rgba(187, 247, 208, 1)",
      };
    }

    if (type === "pending") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#92400e",
        backgroundColor: "#fffbeb",
        borderColor: "rgba(253, 230, 138, 1)",
      };
    }

    if (type === "sent" || type === "contract") {
      return {
        ...CONTRACT_DOC_STYLES.statusPillBase,
        color: "#1d4ed8",
        backgroundColor: "#eff6ff",
        borderColor: "rgba(191, 219, 254, 1)",
      };
    }

    return {
      ...CONTRACT_DOC_STYLES.statusPillBase,
      color: "#475569",
      backgroundColor: "#f8fafc",
      borderColor: "rgba(226, 232, 240, 1)",
    };
  };

  const handleDocumentLoad = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    dispatch(loadAppDocuments(wfId, usrId));
    dispatch(loadAppDocusignDocs(usrId));
    dispatch(loadAppFormLibrary(wfId, usrId));
    dispatch(loadReqDocuments(wfId));
  };

  // Step 1: Merge and tag arrays
  const mergedDocs = [
    ...reqDocuments.map((item) => ({
      ...item,
      type: "req",
      date: item.addedDateTime,
    })),
    ...receivedDocs.map((item) => ({
      ...item,
      type: "received",
      date: item.createdDateTime,
    })),
    ...signDocs.map((item) => ({
      ...item,
      type: "sign",
      date: item.createdDateTime,
    })),
    ...sentDocs.map((item) => ({
      ...item,
      type: "sent",
      date: item.createdDateTime,
    })),
  ];

  // Step 2: Sort by date (latest first, or reverse if needed)
  const sortedDocs = mergedDocs.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const totalDocuments =
    reqDocuments.length + receivedDocs.length + signDocs.length + sentDocs.length;

  let usrId = currentUser.id;
  if (currentUser.linkUser)
    usrId = currentUser.linkUser;

  return (
    <React.Fragment>
      <div className="mt-2 form-group">
        <style>{`
          .contract-docs-table tbody tr:hover td {
            background-color: #f8fbff !important;
          }

          @media (max-width: 991.98px) {
            .contract-docs-table {
              min-width: 980px;
            }
          }
        `}</style>

        <div className="card border-1 shadow-none" style={CONTRACT_DOC_STYLES.card}>
          <div className="card-header border-1" style={CONTRACT_DOC_STYLES.cardHeader}>
            <div className="row">
              <div className="col-md-8">
                <div style={CONTRACT_DOC_STYLES.titleRow}>
                  <span style={CONTRACT_DOC_STYLES.titleIcon}>
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                  </span>
                  <div style={CONTRACT_DOC_STYLES.titleText}>
                    <div style={CONTRACT_DOC_STYLES.title}>Contract Documents</div>
                    <p style={CONTRACT_DOC_STYLES.subtitle}>
                      Download, complete, sign and upload documents.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-right">
                <div style={CONTRACT_DOC_STYLES.headerActions}>
                  <button
                    className="btn btn-sm"
                    style={CONTRACT_DOC_STYLES.refreshButton}
                    onClick={handleDocumentLoad}
                  >
                    <i className="fa fa-refresh" aria-hidden="true"></i>
                    Refresh
                  </button>
                  <button
                    className="btn btn-sm"
                    style={CONTRACT_DOC_STYLES.heroButton}
                    title="Use this feature to upload any documents as may be required."
                    onClick={() => handleUploadShowHide("")}
                  >
                    <i className="fa fa-upload" aria-hidden="true"></i>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body border-1" style={CONTRACT_DOC_STYLES.cardBody}>
            <div style={CONTRACT_DOC_STYLES.utilityRow}>
              <p style={CONTRACT_DOC_STYLES.helperText}>
                Open password protected documents using the first 3 letters of your first name and the first 3 characters of your ID in lowercase. Example: `abc123`.
              </p>
            </div>
            <div style={CONTRACT_DOC_STYLES.statsRow}>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Total Documents</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{totalDocuments}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  All contract-related documents currently available in this step.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Required</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{reqDocuments.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Required documents requested as part of onboarding.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Received</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{receivedDocs.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Files shared back into your contract document workflow.
                </div>
              </div>
              <div style={CONTRACT_DOC_STYLES.statCard}>
                <div style={CONTRACT_DOC_STYLES.statLabel}>Sent / Sign</div>
                <div style={CONTRACT_DOC_STYLES.statValue}>{sentDocs.length + signDocs.length}</div>
                <div style={CONTRACT_DOC_STYLES.statHint}>
                  Documents sent out plus DocuSign items that still need attention.
                </div>
              </div>
            </div>
            <div className="table-responsive" style={CONTRACT_DOC_STYLES.tableWrap}>
              <table className="table align-items-center table-hover mb-0 contract-docs-table" style={CONTRACT_DOC_STYLES.table}>
                <colgroup>
                  <col style={CONTRACT_DOC_STYLES.serialColumn} />
                  <col style={CONTRACT_DOC_STYLES.dateColumn} />
                  <col style={CONTRACT_DOC_STYLES.requirementColumn} />
                  <col style={CONTRACT_DOC_STYLES.notesColumn} />
                  <col style={CONTRACT_DOC_STYLES.statusColumn} />
                  <col style={CONTRACT_DOC_STYLES.actionColumn} />
                </colgroup>
                <thead>
                  <tr>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}></th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Date & Time</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Requirement</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Notes</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Status</th>
                    <th style={CONTRACT_DOC_STYLES.tableHeadCell}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {sortedDocs.map((item, key) => (
                    <tr key={key}>
                      <td style={CONTRACT_DOC_STYLES.cell}>
                        <span style={CONTRACT_DOC_STYLES.serialBadge}>{key + 1}</span>
                      </td>
                      <td style={CONTRACT_DOC_STYLES.cell}>
                        <div style={CONTRACT_DOC_STYLES.datePrimary}>
                          <Moment format="MMM Do YYYY">
                            {item.date}
                          </Moment>
                        </div>
                        <div style={CONTRACT_DOC_STYLES.dateSecondary}>
                          <Moment format="h:mm a">
                            {item.date}
                          </Moment>
                        </div>
                      </td>

                      {/* Handle by type */}
                      {item.type === "req" && (
                        <>
                          {getReqRefDocs(item)}
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "req")}
                        </>
                      )}

                      {item.type === "received" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              onClick={() => handleDownloadFile(item)}
                            >
                              {getDisplayName(item.documentName)}
                            </button>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "received")}
                        </>
                      )}

                      {item.type === "sign" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              onClick={() => handleViewSignedDoc(item, "0")}
                            >
                              {getDisplayName(item.documentName)}
                            </button>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.remarks)}</td>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <span style={getStatusPillStyles(item.signedStatus === "1" ? "signed" : "pending")}>
                              {item.signedStatus === "1" ? "Signed" : "Pending"}
                            </span>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            {item.signedStatus === "1" ? (
                              <button
                                className="btn btn-sm p-0"
                                style={CONTRACT_DOC_STYLES.ellipsisLink}
                                title={item.documentName}
                                aria-label={item.documentName}
                                onClick={() => handleViewSignedDoc(item, "1")}
                              >
                                {getDisplayName(item.documentName)}
                              </button>
                            ) : (
                              <>
                                {item.signedStatus === "0" && (
                                  <a
                                    className="btn btn-sm"
                                    style={CONTRACT_DOC_STYLES.primaryButton}
                                    target="blank"
                                    href={`${process.env.REACT_APP_ESIGN_BASEURL}/${item?.id}_${item.ciid}_${usrId}_${clientDetails?.clientId}_${item.documentName}_contractPartner`}
                                  >
                                    Complete and Sign
                                  </a>
                                )}
                                {item.signedStatus === null && (
                                  <a
                                    className="btn btn-sm"
                                    style={CONTRACT_DOC_STYLES.primaryButton}
                                    target="blank"
                                    href={`${process.env.REACT_APP_ESIGN_BASEURL}/${item?.docId}_${item.ciid}_${usrId}_${clientDetails?.clientId}_${item.documentName}_esignPartner`}
                                  >
                                    Complete and Sign
                                  </a>
                                )}
                              </>
                            )}
                          </td>
                        </>
                      )}

                      {item.type === "sent" && (
                        <>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <button
                              className="btn btn-sm p-0"
                              style={{
                                ...CONTRACT_DOC_STYLES.textButton,
                                ...CONTRACT_DOC_STYLES.requirementPrimary,
                              }}
                              title={item.documentName}
                              aria-label={item.documentName}
                              disabled={docLoading && item.id === docLoadingId}
                              onClick={() => handleDownloadFile(item)}
                            >
                              {docLoading && item.id === docLoadingId && (
                                <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
                              )}
                              {getDisplayName(item.documentName)}
                            </button>
                          </td>
                          <td style={CONTRACT_DOC_STYLES.cell}>{getPopover1(item.notes)}</td>
                          <td style={CONTRACT_DOC_STYLES.cell}><span style={getStatusPillStyles("sent")}>Sent</span></td>
                          <td style={CONTRACT_DOC_STYLES.cell}>
                            <div style={CONTRACT_DOC_STYLES.actionGroup}>
                              <button
                                className="btn btn-sm"
                                style={{
                                  ...CONTRACT_DOC_STYLES.iconButton,
                                  ...CONTRACT_DOC_STYLES.deleteIconButton,
                                }}
                                title="Delete File"
                                onClick={() => handleDeleteFile(item, "doc", item)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {uploadDocShowHide && (
        <UploadDocPopup
          uploadDocShowHide={uploadDocShowHide}
          handleUploadDocModalShowHide={handleUploadShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={
            docType === ""
              ? "Your document has been successfully attached to workbench portal"
              : "Your required document has been successfully attached to workbench portal"
          }
        ></UploadDocPopup>
      )}
      {formShowHide && (
        <ViewForm
          formShowHide={formShowHide}
          handleFormShowHide={handleFormShowHide}
          workflowTask={wfTask}
          selectedForm={formObj}
        ></ViewForm>
      )}
    </React.Fragment>
  );
}
